<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->

<div>
  <div class="save-button">
    <oneapp-button
      [action]="ButtonAction.SAVE"
      [type]="ButtonType.PRIMARY"
      [disabled]="!unsavedChangesExist || !isActionsValid || isDeleting"
      (buttonClick)="onSubmit()"
    ></oneapp-button>
  </div>
  <div class="section">
    <span i18n="@@notificationsTriggerDescriptionText" class="sub-header"
      >Automate your workflow by setting up actions like notifications triggered by specific
      events.</span
    >
    <div fxLayout="row" fxLayoutGap="8px">
      <oneapp-button
        i18n-text="@@addProtocolNotification"
        text="Add Protocol Notification"
        (buttonClick)="onAddProtocolNotification()"
        [icon]="faPlus"
        [disabled]="actionsLoading"
      ></oneapp-button>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div *ngIf="actionsLoading" fxFill fxLayoutAlign="center center">
    <fa-icon
      class="icon loading_spinner"
      [icon]="faSpinnerThird"
      aria-label="loading spinner"
    ></fa-icon>
  </div>
  <div class="section" *ngIf="!actionsLoading">
    <div *ngFor="let action of actions; index as index; last as last">
      <div [ngSwitch]="action.type">
        <div *ngSwitchCase="ActionType.SendEmail">
          <oneapp-send-email-action
            [action]="action"
            [incidentQuestions]="incidentQuestions"
            [workflowId]="workflowIdInDesigner"
            (deleteRequested)="onDeleteAction(index)"
            (actionIsChanged)="onActionChanged(index)"
            [isDeleting]="isDeleting"
          ></oneapp-send-email-action>
        </div>
      </div>
      <mat-divider *ngIf="!last"></mat-divider>
    </div>
  </div>
</div>
